import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

type MutationPayload = FormData

type MutationResponse = {
  timestamp: string,
  statusCode: number,
  status: string,
  message: string,
  data: any
};

export const useSendWithMediaMutation = () => {
  const mutationFn = useGetMutationFn<MutationPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred during WhatsApp message sending',
    endpoint: '/api/admin/whatsapp/send-with-media',
    method: 'POST',
  });

  return useMutation<MutationResponse, Error, MutationPayload>({ mutationFn });
};